/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Empty_State_Clear_FiltersInputs */



/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Empty_State_Clear_FiltersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const empty_state_clear_filters = /** @type {((inputs?: Empty_State_Clear_FiltersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_State_Clear_FiltersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Filter zurücksetzen")
	return /** @type {LocalizedString} */ ("Clear filters")
});